// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/fr"
import GenericContent from "src/components/pages/GenericContent/GenericContent"

const GenericContentPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `genericContentPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.genericContentPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <GenericContent sections={sections} />
    </Layout>
  )
}

export default GenericContentPageFr

export const query = graphql`
  query GenericContentPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    genericContentPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
